import { create } from 'zustand'

type BatchSelectState = {
  enabled: boolean
  selectedIds: string[]
  setEnabled: (enabled: boolean) => void
  toggle: (id: string) => void
  selectMany: (ids: string[]) => void
  selectAll: (ids: string[]) => void
  clear: () => void
  isSelected: (id: string) => boolean
}

export const useBatchSelectStore = create<BatchSelectState>((set, get) => ({
  enabled: false,
  selectedIds: [],
  setEnabled: (enabled) =>
    set(enabled ? { enabled: true } : { enabled: false, selectedIds: [] }),
  toggle: (id) =>
    set((state) => {
      const has = state.selectedIds.includes(id)
      return {
        selectedIds: has
          ? state.selectedIds.filter((x) => x !== id)
          : [...state.selectedIds, id],
      }
    }),
  selectMany: (ids) =>
    set((state) => {
      const next = new Set(state.selectedIds)
      ids.forEach((id) => next.add(id))
      return { selectedIds: [...next] }
    }),
  selectAll: (ids) => set({ selectedIds: [...new Set(ids)] }),
  clear: () => set({ selectedIds: [] }),
  isSelected: (id) => get().selectedIds.includes(id),
}))
